/**
 * Item with a checkbox at the left side that allows the item to be selected or not
 */

import React from 'react';

import Checkbox from './forms/Checkbox';

export default class SelectableListItem extends React.Component {
    render() {
        let TagName = this.props.tagName || 'li',
            classes = [
                'SelectableListItem', this.props.className
            ],
            style = Object.assign({}, this.props.style);

        return (
            <TagName className={classes.join(' ')} style={style}>
                <Checkbox checked={this.props.checked} onChange={this.handleChange.bind(this)}/>
                <div className="content">
                    {this.props.children}
                </div>
            </TagName>
        );
    }

    handleChange(checkbox) {
        this.props.onChange &&  this.props.onChange(checkbox.checked);
    }
}
